import React from 'react';
import styled from 'styled-components';
import heartificialIntelligenceImage from '../assets/images/9efa78f2-8c13-4bb2-a21e-6f22afa32b47.png';

const SectionWrapper = styled.section`
  width: 100%;
  overflow: hidden;
  background:
    radial-gradient(circle at 20% 45%, rgba(255, 255, 255, 0.42), transparent 28%),
    radial-gradient(circle at 78% 21%, rgba(255, 255, 255, 0.4), transparent 25%),
    linear-gradient(to bottom, #fbfdff 0%, #e8f8ff 21%, #c9efff 48%, #b9e9fb 100%);
  padding: 1.8rem 1.15rem 4.5rem;
`;

const ContentContainer = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const HeadingRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  margin-bottom: 2.25rem;
`;

const Title = styled.h2`
  color: #ae1d4e;
  font-size: clamp(1.65rem, 3.1vw, 2.2rem);
  font-weight: 700;
  letter-spacing: 0.04em;
`;

const Partner = styled.p`
  color: #575757;
  font-size: clamp(1.25rem, 2.8vw, 1.85rem);
  font-weight: 300;

  @media (max-width: 560px) {
    display: none;
  }
`;

const BodyText = styled.p`
  color: #070b10;
  font-size: clamp(1rem, 2vw, 1.3rem);
  line-height: 1.48;
  letter-spacing: 0.09em;
  margin-bottom: 1rem;
`;

const Tagline = styled.p`
  color: #070b10;
  font-size: clamp(1.05rem, 2.2vw, 1.4rem);
  font-weight: 700;
  line-height: 1.35;
  letter-spacing: 0.06em;
  text-align: center;
  margin: 2.1rem auto 1.2rem;
  max-width: 900px;
`;

const AiVisual = styled.div`
  position: relative;
  width: 100%;
`;

const AiArtwork = styled.img`
  display: block;
  position: relative;
  z-index: 1;
  width: 100%;
  height: auto;
`;

const MissionPartner = styled.p`
  position: absolute;
  bottom: 3%;
  left: 0;
  right: 0;
  z-index: 0;
  margin: 0 auto;
  width: 83%;
  color: #49a9d8;
  font-size: clamp(1.7rem, 4vw, 3rem);
  font-weight: 700;
  letter-spacing: 0.1em;
  text-align: center;

  @media (max-width: 560px) {
    bottom: 2%;
    width: 78%;
    font-size: 1.45rem;
  }
`;

const WhyHeartsSection = () => (
  <SectionWrapper>
    <ContentContainer>
      <HeadingRow>
        <Title>Why HEARTS?</Title>
        <Partner>Sync Innovations</Partner>
      </HeadingRow>
      <BodyText>
        HEARTS brings together science, communication and artificial intelligence.<br />
        We explore AI in medicine as a scientific and statistical methodology, including its evolving role in research, clinical decision-making and medical innovation.<br />
        At the same time, we use AI as a practical tool: to structure scientific knowledge, make medical science more accessible, support doctors in everyday practice and facilitate new collaborations between researchers and scientific stakeholders.
      </BodyText>
      <BodyText>
        For us, AI in the medical arts is an opportunity to strengthen science, improve communication and reduce unnecessary workload, so that doctors can devote more time to their patients and medicine can become as human as it was always meant to be.
      </BodyText>
      <BodyText>
        Through strong media partners, a local presence and the internationalisation of our events, we help to raise the international profile of leading Austrian and international research.
      </BodyText>
      <Tagline>
        HEARTS democratizes science. HEARTS strengthens prevention.<br />
        HEARTS is medicine through communication.
      </Tagline>
    </ContentContainer>
    <AiVisual>
      <AiArtwork
        src={heartificialIntelligenceImage}
        alt="HEARTIFICIAL INTELLIGENCE: a human and robotic hand reaching towards each other"
      />
      <MissionPartner>MISSION PARTNER</MissionPartner>
    </AiVisual>
  </SectionWrapper>
);

export default WhyHeartsSection;
